<template>
  <el-dialog
    title="添加商品"
    :visible.sync="selfVisible"
    width="600px"
    @close="handleClose"
  >
    <el-form ref="form" :model="form" label-width="110px" :rules="rules">
      <el-form-item label="购买商品：" prop="productName">
        <el-select
          v-model="form.productName"
          filterable
          remote
          reserve-keyword
          placeholder="请输入购买商品"
          :remote-method="remoteMethod"
          :loading="selectLoading"
          @focus="clearSelct">
          <el-option
            v-for="item in options"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="购买数量：" prop="buyNum">
        <el-input type="text" v-model="form.buyNum"></el-input>
      </el-form-item>
      <el-row type="flex" justify="center" style="margin-top: 45px;">
        <el-button
          class="standard-button"
          style="margin-right: 10px;"
          @click="handleClose"
        >取消</el-button>
        <el-button
          class="standard-button"
          type="primary"
          :loading="loading"
          @click="handlerConfirm"
        >确认</el-button>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { getCigarOrBoutique } from '@/api/audit';
import { validCurrency } from '@/utils/validate';

export default {
  name: 'addDialog',
  data() {
    const validNumber = (rule, value, callback) => {
      if (validCurrency(value)) {
        callback();
      } else {
        callback(new Error('请输入正确数字值!'));
      }
    };
    return {
      selectLoading: false,
      selfVisible: false,
      options: [],
      form: {
        productName: '',
        buyNum: '',
      },
      rules: {
        productName: [
          { required: true, message: '商品名称不能为空', trigger: 'change' },
        ],
        buyNum: [
          { required: true, message: '数量不能为空', trigger: 'blur' },
          { validator: validNumber, trigger: 'blur' },
        ],
      },
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    configPath: {
      type: String,
      default: '',
    },
  },
  watch: {
    visible: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.selfVisible = newValue;
        }
      },
      immediate: true,
    },
  },
  methods: {
    getCigarOrBoutique(queryString) {
      return getCigarOrBoutique(queryString).then((res) => {
        if (res.success) {
          if (res.data) {
            this.options = res.data;
            this.selectLoading = false;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    remoteMethod(query) {
      if (query !== '') {
        this.selectLoading = true;
        this.getCigarOrBoutique(query);
      } else {
        this.options = [];
      }
    },
    clearSelct() {
      this.options = [];
      this.resetForm();
    },
    handlerConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('confirm', this.form);
          this.resetForm();
          return true;
        }
        return false;
      });
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    handleClose() {
      this.resetForm();
      this.$emit('close');
    },
  },
};
</script>

<style lang="stylus" scoped>
>>>.el-dialog__header
  padding 13px 20px
  .el-dialog__headerbtn
    top 16px
</style>
